export const QA_NAME_ADD_REQUEST_BUTTON = 'addRequest'

export const QA_NAME_ADD_POST_BUTTON = 'addPost'

export const QA_NAME_HIDE_MESSAGE_BUTTON = 'hideMessage'
